import { FC }               from 'react';
import Style                from './Select.style';
import type { SelectProps } from 'antd';

type TProps = SelectProps;

export const Select: FC<TProps> = ({ options, ...props }) => {

  return (
    <Style options={options} {...props} />
  );

};
